import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NormalLayoutComponent } from "./components/normal-layout/normal-layout.component";
import { SentryTestComponent } from "./components/sentry-test/sentry-test.component";
import { SpecialtyGuard } from "./guards/specialty.guard";
import { StartScreeningGuard } from "./guards/start-screening.guard";
import { DevelopmentPageComponent } from "./pages/development-page/development-page.component";
import { FaqsPageComponent } from "./pages/faqs-page/faqs-page.component";
import { HomePageComponent } from "./pages/home-page/home-page.component";
import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";
import { ScreeningToolLandingPageComponent } from "./pages/screening-tool-landing-page/screening-tool-landing-page.component";
import { ScreeningToolPageComponent } from "./pages/screening-tool-page/screening-tool-page.component";
import { WhatIsEpiPageComponent } from "./pages/what-is-epi-page/what-is-epi-page.component";

const routes: Routes = [
    {
        path: "screening-tool",
        title: "Screening Tool Questionnaire",
        component: ScreeningToolPageComponent,
        canActivate: [SpecialtyGuard]
    },
    {
        path: "test-sentry",
        component: SentryTestComponent
    },
    {
        path: "",
        component: NormalLayoutComponent,
        children: [
            { path: "", redirectTo: "home", pathMatch: "full" },
            {
                path: "what-is-epi",
                title: "What is EPI? Page",
                component: WhatIsEpiPageComponent
            },
            {
                path: "development",
                title: "Development Page",
                component: DevelopmentPageComponent
            },
            {
                path: "screening-tool-landing",
                title: "Screening Tool Landing",
                component: ScreeningToolLandingPageComponent,
                runGuardsAndResolvers: "always",
                canActivate: [StartScreeningGuard]
            },
            {
                path: "faqs",
                title: "FAQs Page",
                component: FaqsPageComponent
            },
            { path: "home", title: "Home Page", component: HomePageComponent },
            { path: "**", component: PageNotFoundComponent, title: "404" }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
